export default __webpack_public_path__ + "static/media/icon_chevron_down.2f7f9caf.svg";